import type {
	SettingsFlow,
	UpdateSettingsFlowBody,
	UpdateSettingsFlowWithProfileMethod,
} from "@ory/kratos-client";
import type React from "react";
import { Alert } from "~/components/Alert";
import { Flow } from "~/components/KratosFlow";

interface Props {
	flow: SettingsFlow;
	onSubmit: (values: UpdateSettingsFlowBody) => Promise<void>;
	disabled: boolean;
}

export const ProfileSettings: React.FC<Props> = ({
	flow,
	onSubmit,
	disabled,
}) => {
	return (
		<section className="mt-12">
			<h2 className="font-normal text-xl">PROFILE</h2>
			{disabled && (
				<Alert type="info" withIcon>
					You cannot update your profile because you belong to organization and
					you do not have authority to edit it.
				</Alert>
			)}
			<Flow<UpdateSettingsFlowWithProfileMethod & { method: "profile" }>
				disabled={disabled}
				onSubmit={onSubmit}
				flow={flow}
				only="profile"
				sortComponents={[
					{ name: "traits.name.first" },
					{ name: "traits.name.last" },
					{ name: "traits.email" },
				]}
				setLabelTexts={[
					{
						query: { name: "method", type: "submit", value: "profile" },
						value: "Update Profile",
					},
				]}
				nodeDisablers={[
					{
						target: { name: "method", value: "profile" },
						keys: [
							"traits.name.first" as keyof UpdateSettingsFlowWithProfileMethod,
							"traits.name.last" as keyof UpdateSettingsFlowWithProfileMethod,
							"traits.email" as keyof UpdateSettingsFlowWithProfileMethod,
						],
						allowEmpty: false,
						allowNotChanged: false,
					},
				]}
			/>
		</section>
	);
};
